import React, { useState, useEffect, useContext } from "react";
import { Button, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { excelMapping, ExportToExcel, now } from "../utils/utilFuctions";
import { BASE_URL_PAYNOW } from "../utils/Constants";
import { API_ENDPOINTS } from "../utils/apiEndpoints";

// import { CLIENT } from "../../config";

export const columns = [
  {
    dataField: "merchantTransactionid",
    text: "Merchant Txnt ID",
    color: "#586275",
  },
  {
    dataField: "refid",
    text: "Ref id",
    color: "#586275",
  },
  {
    dataField: "utnno",
    text: "UTR No",
    color: "#586275",
  },
  {
    dataField: "transactiontype",
    text: "Transaction type",
    color: "#586275",
  },
  {
    dataField: "transactionAmount",
    text: "Amount",
    color: "#586275",
  },
  {
    dataField: "cgstAmount",
    text: "CGST Amount",
    color: "#586275",
  },
  {
    dataField: "sgstAmount",
    text: "SGST Amount",
    color: "#586275",
  },
  {
    dataField: "chargesAmount",
    text: "Charges",
    color: "#586275",
  },
  {
    dataField: "debitAmount",
    text: "Debit",
    color: "#586275",
  },
  {
    dataField: "creditAmount",
    text: "Credit",
    color: "#586275",
  },
  {
    dataField: "balance",
    text: "Balance",
    color: "#586275",
  },
  {
    dataField: "status",
    text: "Status",
    color: "#000",
  },

  {
    dataField: "createdOn",
    text: "Created On",
    color: "#586275",
  },
];

const Settlement = ({ setDetails }) => {
  // const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [data, setData] = useState([]);
  const [dataToDisplay, setDataToDisplay] = useState([]);
  const [endDate, setEndDate] = useState(new Date());
  const [settlementButton, setsettlementButton] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [offset, setOffset] = useState(10);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(0);

  // const location = useLocation();
  // const InternalMerchentID = new URLSearchParams(location.search).get(
  // "InternalMerchentID"
  // );
  // const InternalMerchentName = new URLSearchParams(location.search).get(
  // "InternalMerchentName"
  // );

  const dateFormatter = (d) => {
    const date = new Date(d);
    return `${date.getFullYear()}-${
      date.getMonth() > 9 ? date.getMonth() + 1 : "" + (date.getMonth() + 1)
    }-${date.getDate() > 9 ? date.getDate() : "0" + date.getDate()}`;
  };

  const GetUserSettlement = async () => {
    const { username, password } = JSON.parse(
      sessionStorage.getItem("basic_auth")
    );
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username + ":" + password).toString("base64")
      );
      myHeaders.append(
        "Cookie",
        ".AspNetCore.Identity.Application=CfDJ8C2tCbekulxMluKiJNBujdkkzObwoeb59O-SVUHx9_cQEHv6NWn3sdDvVPgnOoqHYiJ-uRyNt3rB4kv0Pl-zBNex5EMAboBjHw4lOKm-WRzq93w_wpCTjC6MGkk9-LYTNpYDGM0PQHUhvbiRdTPeHfkpPO3ELkuDbZq2olf4E13G98fwt5m1_XjyJUrLCpOf7am3mR3X14e3HRkg6O39EGykN8GoGrfUAnAflTDe4AZYuwXOG55wwP4tJBE3rC9qiWcHCqJ1OiLH-l8p03bXx4nm23gThO8ZYH5vukH7hS5so58mABbjSoTo3Yw8FVh5tH4Su3irB0C1DlA7rRQMWqAauto0FhYv9GizdvhXXKKDyx0zBfEcxEGmdlWXhXpSNH3ZmX2gDJKQM1CvPk9zbw22jcy0abg06TeJbUb4xO8Uej1HQhMPbZW6VaQBuFHWqJLS2KVKy07f-CmXJm7YTlAkQfQPO_uvw2zVYCFBKbvYvfXbVjx5jS0kO7iqENB6A7qDIvT8hn3IlnEuUwsTeaImHwpUYEt-kwgmm-zlYL4FI7Tjm1Legvc_qbLR1sM2izOqkoUPxenr2a0jppHf06CqXFCnxC_Q1LvW9BaxWKKhwn2MXzMigb_kqwq69P6JctfnGsxR9Cox5ynKqZ6M7K2762vKFiRdRVB8MkGomwa6"
      );

      var raw = JSON.stringify({
        fromDate: dateFormatter(startDate),
        toDate: dateFormatter(endDate),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_PAYNOW}${API_ENDPOINTS.GetUserSettlement}`,
        requestOptions
      );
      const data = await res.json();
      setData(data);
      setDataToDisplay(data);

      setLoading(false);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    GetUserSettlement();
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    GetUserSettlement();
  };

  return (
    <div
      className=" p-4"
      style={{ backgroundColor: "#F1EFEF", fontFamily: "poppins" }}
    >
      {loading && (
        <div className="loader-container">
          <div className="loader"></div>
          <div className="loader-text">Please wait...</div>
        </div>
      )}
      <div className="card rounded m-2" style={{ background: "white" }}>
        <div
          className="row m-2 p-3 align-items-center"
          id="parentFilters"
          style={{
            background: "white",
            borderRadius: "0.5rem",
            // boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <div
            className="m-0 p-0"
            style={{
              fontFamily: "Poppins",
              fontSize: "28px",
              fontWeight: "700",
              color: "#2c3e50",
              minWidth: "150px",
              marginBottom: "10px",
            }}
          >
            Settlement
          </div>

          <div
            id="filters"
            style={{
              display: "flex",
              gap: "0.5rem",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "flex-end",
              flexGrow: 1,
            }}
          >
            <Form.Group
              id="parentDatePicker"
              style={{
                display: "flex",
                gap: "0.5rem",
                alignItems: "center",
                marginBottom: "0",
              }}
            >
              <DatePicker
                className="form-control rounded-1"
                style={{
                  borderColor: "#ccc",
                  height: "38px",
                  padding: "0.375rem 0.75rem",
                  fontSize: "0.875rem",
                }}
                selected={startDate}
                onChange={(date) => setStartDate(date)}
              />
              <DatePicker
                className="form-control rounded-1"
                style={{
                  borderColor: "#ccc",
                  height: "38px",
                  padding: "0.375rem 0.75rem",
                  fontSize: "0.875rem",
                }}
                selected={endDate}
                onChange={(date) => setEndDate(date)}
              />
            </Form.Group>

            <Button
              className="btn btn-lg"
              style={{
                fontSize: "0.75rem",
                background: "#2c3e50",
                color: "white",
                padding: "0.4rem 1rem",
                borderRadius: "0.25rem",
              }}
              onClick={handleSubmit}
            >
              Search
            </Button>

            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                cursor: "pointer",
                border: "1px solid rgba(43, 193, 85, 1)",
                backgroundColor: "rgba(43, 193, 85, 0.1)",
                color: "rgba(43, 193, 85, 1)",
                borderRadius: "0.4rem",
                padding: "0.3rem 1rem",
                minWidth: "170px",
              }}
              onClick={() => {
                ExportToExcel(
                  `payin_ledger_Report_${now()}`,
                  excelMapping(data, columns)
                );
              }}
            >
              <img
                alt=""
                // src={require("../assets/images/excel.png")}
                style={{ width: "1.6rem", marginRight: "10px" }}
              />
              <strong style={{ fontSize: "0.8rem" }}>Export to Excel</strong>
            </div>
          </div>
        </div>

        <div className=" bg-white p-2 ">
          <table className="table" style={{ fontFamily: "poppins" }}>
            <thead>
              <tr>
                <th
                  className=" text-white text-center py-3 "
                  style={{ background: "#2c3e50" }}
                >
                  {" "}
                  Order Id
                </th>
                <th
                  className=" text-white text-center py-3 "
                  style={{ background: "#2c3e50" }}
                >
                  Settlement Amount
                </th>
                <th
                  className=" text-white text-center py-3"
                  style={{ background: "#2c3e50" }}
                >
                  Transaction Amount
                </th>
                <th
                  className=" text-white text-center py-3 "
                  style={{ background: "#2c3e50" }}
                >
                  From value
                </th>
                <th
                  className=" text-white text-center py-3 "
                  style={{ background: "#2c3e50" }}
                >
                  To value
                </th>

                <th
                  className=" text-white text-center py-3 "
                  style={{ background: "#2c3e50" }}
                >
                  Date
                </th>
                <th
                  className=" text-white text-center py-3 "
                  style={{ background: "#2c3e50" }}
                >
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="9" className="text-center">
                    Loading...
                  </td>
                </tr>
              ) : (
                dataToDisplay.map((item) => (
                  <tr key={item.UserName} style={{ border: "none" }}>
                    <td
                      className="text-center align-middle"
                      style={{ border: "none" }}
                    >
                      {item.orderid || "NA"}
                    </td>
                    <td
                      className="text-center align-middle"
                      style={{ border: "none" }}
                    >
                      {item.settlementAmount || "NA"}
                    </td>
                    <td
                      className="text-center align-middle"
                      style={{ border: "none" }}
                    >
                      {item.transactionAmount || "NA"}
                    </td>
                    <td
                      className="text-center align-middle"
                      style={{ border: "none" }}
                    >
                      {item.fromvalue || "NA"}
                    </td>
                    <td
                      className="text-center align-middle"
                      style={{ border: "none" }}
                    >
                      {item.tovalue || "NA"}
                    </td>

                    <td
                      className="text-center align-middle"
                      style={{ border: "none" }}
                    >
                      {item.createdOn}
                    </td>
                    <td
                      className="text-center align-middle"
                      style={{ border: "none" }}
                    >
                      {item.actionvalue !== undefined &&
                      item.actionvalue === "Settled" ? (
                        <label
                          style={{
                            padding: "8px",
                            border: "1px solid",
                            height: "2rem",
                            width: "100px",
                            backgroundColor: "rgba(43, 193, 85, 0.1)",
                            color: "rgba(43, 193, 85, 1)",
                            borderColor: "rgba(43, 193, 85, 1)",
                            borderRadius: ".4rem",
                            fontSize: ".8rem",
                            textAlign: "center",
                          }}
                          className="badge badge-success"
                        >
                          {"Settled"}
                        </label>
                      ) : (
                        <label
                          style={{
                            padding: "8px",
                            borderRadius: ".4rem",
                            width: "100px",
                            backgroundColor: "rgba(255, 238, 0, 0.1)",
                            color: "rgba(255, 196, 0, 1)",
                            border: "1px solid rgba(255, 238, 0, 1)",
                            borderColor: "rgba(255, 238, 0, 1)",
                            fontSize: "0.8rem",
                            textAlign: "center",
                          }}
                          className="badge badge-warning"
                        >
                          {item.actionvalue}
                        </label>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          {/* {data.length <= 0 && <NoDataFound />} */}
          <hr />
          <Pagination
            page={currentPage}
            limit={pages}
            callback={(page, offsetPassed) => {
              if (currentPage != page) setCurrentPage(page);
              if (offset != offsetPassed) setOffset(offsetPassed);
            }}
            count={dataToDisplay.length}
            total={total}
          />
        </div>
      </div>
    </div>
  );
};

const Pagination = ({ page, limit, callback, total, count }) => {
  console.table({ page, limit, callback });
  return (
    <div
      className="row"
      style={{
        display: "flex",
        alignItems: "end",
        width: "100%",
        margin: "10px 0px",
        justifyContent: "space-between",
      }}
    >
      <div>
        <strong>{`Showing ${count} of ${total} entries`}</strong>
      </div>
      <div>
        {page - 2 > 0 ? (
          <Button
            onClick={() => {
              callback(page - 1);
            }}
            variant="light"
          >
            {"Previous"}
          </Button>
        ) : null}

        {page - 1 > 0 ? (
          <Button
            onClick={() => {
              callback(page - 1);
            }}
            variant="light"
          >
            {" "}
            {(page - 1).toString()}
          </Button>
        ) : null}
        <Button variant="primary"> {page.toString()}</Button>
        <Button
          onClick={() => {
            callback(page + 1);
          }}
          variant="light"
        >
          {"Next"}
        </Button>
      </div>
    </div>
  );
};

export default Settlement;
